'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cashtag = require('./cashtag');

var _cashtag2 = _interopRequireDefault(_cashtag);

var _punct = require('./punct');

var _punct2 = _interopRequireDefault(_punct);

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _spaces = require('./spaces');

var _spaces2 = _interopRequireDefault(_spaces);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var validCashtag = (0, _regexSupplant2.default)('(^|#{spaces})(\\$)(#{cashtag})(?=$|\\s|[#{punct}])', { cashtag: _cashtag2.default, spaces: _spaces2.default, punct: _punct2.default }, 'gi');

exports.default = validCashtag;
module.exports = exports['default'];